import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/unstableZones";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(`${resource}/getList${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export { apply, delItem, index };
